import React, { useState } from "react"; // Import useState
import "./default.css";
import { Link } from "react-router-dom";

const Index = () => { 
  const [isHovered, setIsHovered] = useState(false); 

  const linkStyle = {
    cursor: 'pointer',
    padding: '12px',
    border: '1px solid #A8CED0',
    color: '#A8CED0',
    textDecoration: isHovered ? 'underline' : 'none',
    backgroundColor: 'transparent', 
  };

  return (
    <div className="fullPage">
      <div className="binaryBg">
        {/* <p>
          01001001 00100111 01101101 00100000 01100001 00100000 01110000
          01100001 01110011 01110011 01101001 01101111 01101110 01100001
          01110100 01100101 00100000 01010111 01100101 01100010 00100000
          01000100 01100101 01110110 01100101 01101100 01101111 01110000
          01100101 01110010 00100000 01100001 01101110 01100100 00100000
          01010011 01101111 01100110 01110100 01110111 01100001 01110010
          01100101 00100000 01000101 01101110 01100111 01101001 01101110
          01100101 01100101 01110010 00100000 01110111 01101001 01110100
          01101000 00100000 01100001 00100000 01101011 01100101 01100101
          01101110 00100000 01101001 01101110 01110100 01100101 01110010
          01100101 01110011 01110100 00100000 01101001 01101110 00100000
          01101001 01101110 01101110 01101111 01110110 01100001 01110100
          01101001 01101111 01101110 00100000 01100001 01101110 01100100
          00100000 01100010 01110101 01110011 01101001 01101110 01100101
          01110011 01110011 00101110 00100000 01010111 01101001 01110100
          01101000 00100000 01100001 00100000 01110011 01110100 01110010
          01101111 01101110 01100111 00100000 01100110 01101111 01110101
          01101110 01100100 01100001 01110100 01101001 01101111 01101110
          00100000 01101001 01101110 00100000 01100011 01101111 01101101
          01110000 01110101 01110100 01100101 01110010 00100000 01110011
          01100011 01101001 01100101 01101110 01100011 01100101 00100000
          01100001 01101110 01100100 00100000 01100101 01111000 01110000
          01100101 01110010 01101001 01100101 01101110 01100011 01100101
          00100000 01101001 01101110 00100000 01100100 01100101 01110110
          01100101 01101100 01101111 01110000 01101001 01101110 01100111
          00100000 01101101 01101111 01100100 01100101 01110010 01101110
          00100000 01110111 01100101 01100010 00100000 01100001 01110000
          01110000 01101100 01101001 01100011 01100001 01110100 01101001
          01101111 01101110 01110011 00101100 00100000 01001001 00100000
          01110100 01101000 01110010 01101001 01110110 01100101 00100000
          01101111 01101110 00100000 01100011 01110010 01100101 01100001
          01110100 01101001 01101110 01100111 00100000 01100011 01110101
          01110100 01110100 01101001 01101110 01100111 00101101 01100101
          01100100 01100111 01100101 00100000 01110011 01101111 01101100
          01110101 01110100 01101001 01101111 01101110 01110011 00100000
          01110100 01101000 01100001 01110100 00100000 01110000 01110101
          01110011 01101000 00100000 01110100 01101000 01100101 00100000
          01100010 01101111 01110101 01101110 01100100 01100001 01110010
          01101001 01100101 01110011 00100000 01101111 01100110 00100000
          01110100 01100101 01100011 01101000 01101110 01101111 01101100
          01101111 01100111 01111001 00101110 00001010 00001010 01001101
          01111001 00100000 01101010 01101111 01110101 01110010 01101110
          01100101 01111001 00100000 01101001 01101110 00100000 01110011
          01101111 01100110 01110100 01110111 01100001 01110010 01100101
          00100000 01100100 01100101 01110110 01100101 01101100 01101111
          01110000 01101101 01100101 01101110 01110100 00100000 01101001
          01110011 00100000 01100100 01110010 01101001 01110110 01100101
          01101110 00100000 01100010 01111001 00100000 01100001 00100000
          01100100 01100101 01110011 01101001 01110010 01100101 00100000
          01110100 01101111 00100000 01100010 01101100 01100101 01101110
          01100100 00100000 01100011 01110010 01100101 01100001 01110100
          01101001 01110110 01101001 01110100 01111001 00100000 01110111
          01101001 01110100 01101000 00100000 01100110 01110101 01101110
          01100011 01110100 01101001 01101111 01101110 01100001 01101100
          01101001 01110100 01111001 00101100 00100000 01100011 01110010
          01100001 01100110 01110100 01101001 01101110 01100111 00100000
          01110101 01110011 01100101 01110010 00101101 01100011 01100101
          01101110 01110100 01110010 01101001 01100011 00100000 01100101
          01111000 01110000 01100101 01110010 01101001 01100101 01101110
          01100011 01100101 01110011 00100000 01110100 01101000 01100001
          01110100 00100000 01101110 01101111 01110100 00100000 01101111
          01101110 01101100 01111001 00100000 01101101 01100101 01100101
          01110100 00100000 01100010 01110101 01110100 00100000 01100101
          01111000 01100011 01100101 01100101 01100100 00100000 01100101
          01111000 01110000 01100101 01100011 01110100 01100001 01110100
          01101001 01101111 01101110 01110011 00101110 00100000 01000110
          01110010 01101111 01101101 00100000 01110011 01101100 01100101
          01100101 01101011 00100000 01100110 01110010 01101111 01101110
          01110100 00101101 01100101 01101110 01100100 00100000 01100100
          01100101 01110011 01101001 01100111 01101110 01110011 00100000
          01110100 01101111 00100000 01110010 01101111 01100010 01110101
          01110011 01110100 00100000 01100010 01100001 01100011 01101011
          00101101 01100101 01101110 01100100 00100000 01100001 01110010
          01100011 01101000 01101001 01110100 01100101 01100011 01110100
          01110101 01110010 01100101 01110011 00101100 00100000 01001001
          00100000 01100101 01101110 01101010 01101111 01111001 00100000
          01110100 01100001 01101011 01101001 01101110 01100111 00100000
          01101111 01101110 00100000 01100011 01101000 01100001 01101100
          01101100 01100101 01101110 01100111 01100101 01110011 00100000
          01110100 01101000 01100001 01110100 00100000 01110010 01100101
          01110001 01110101 01101001 01110010 01100101 00100000 01100010
          01101111 01110100 01101000 00100000 01110100 01100101 01100011
          01101000 01101110 01101001 01100011 01100001 01101100 00100000
          01110000 01110010 01101111 01100110 01101001 01100011 01101001
          01100101 01101110 01100011 01111001 00100000 01100001 01101110
          01100100 00100000 01110011 01110100 01110010 01100001 01110100
          01100101 01100111 01101001 01100011 00100000 01110100 01101000
          01101001 01101110 01101011 01101001 01101110 01100111 00101110
          00001010 00001010 01001001 01101110 00100000 01100001 01100100
          01100100 01101001 01110100 01101001 01101111 01101110 00100000
          01110100 01101111 00100000 01101101 01111001 00100000 01110100
          01100101 01100011 01101000 01101110 01101001 01100011 01100001
          01101100 00100000 01110011 01101011 01101001 01101100 01101100
          01110011 00101100 00100000 01001001 00100000 01101000 01100001
          01110110 01100101 00100000 01100001 00100000 01100100 01100101
          01100101 01110000 00100000 01100001 01110000 01110000 01110010
          01100101 01100011 01101001 01100001 01110100 01101001 01101111
          01101110 00100000 01100110 01101111 01110010 00100000 01110100
          01101000 01100101 00100000 01100010 01110101 01110011 01101001
          01101110 01100101 01110011 01110011 00100000 01110011 01101001
          01100100 01100101 00100000 01101111 01100110 00100000 01110100
          01100101 01100011 01101000 01101110 01101111 01101100 01101111
          01100111 01111001 00101110 00100000 01001001 00100000 01100010
          01100101 01101100 01101001 01100101 01110110 01100101 00100000
          01110100 01101000 01100001 01110100 00100000 01101001 01101110
          01101110 01101111 01110110 01100001 01110100 01101001 01101111
          01101110 00100000 01101001 01110011 00100000 01101101 01101111
          01110011 01110100 00100000 01101001 01101101 01110000 01100001
          01100011 01110100 01100110 01110101 01101100 00100000 01110111
          01101000 01100101 01101110 00100000 01100001 01101100 01101001
          01100111 01101110 01100101 01100100 00100000 01110111 01101001
          01110100 01101000 00100000 01100010 01110101 01110011 01101001
          01101110 01100101 01110011 01110011 00100000 01100111 01101111
          01100001 01101100 01110011 00101100 00100000 01100001 01101110
          01100100 00100000 01001001 00100000 01100011 01101111 01101110
          01110100 01101001 01101110 01110101 01101111 01110101 01110011
          01101100 01111001 00100000 01110011 01100101 01100101 01101011
          00100000 01101111 01110000 01110000 01101111 01110010 01110100
          01110101 01101110 01101001 01110100 01101001 01100101 01110011
          00100000 01110100 01101111 00100000 01101101 01100101 01110010
          01100111 01100101 00100000 01110100 01101000 01100101 01110011
          01100101 00100000 01110100 01110111 01101111 00100000 01110111
          01101111 01110010 01101100 01100100 01110011 00101110 00100000
          01010111 01101000 01100101 01110100 01101000 01100101 01110010
          00100000 01101001 01110100 00100111 01110011 00100000 01101111
          01110000 01110100 01101001 01101101 01101001 01111010 01101001
          01101110 01100111 00100000 01110111 01101111 01110010 01101011
          01100110 01101100 01101111 01110111 01110011 00101100 00100000
          01100100 01100101 01110110 01100101 01101100 01101111 01110000
          01101001 01101110 01100111 00100000 01110011 01100011 01100001
          01101100 01100001 01100010 01101100 01100101 00100000 01100001
          01110000 01110000 01101100 01101001 01100011 01100001 01110100
          01101001 01101111 01101110 01110011 00101100 00100000 01101111
          01110010 00100000 01100101 01111000 01110000 01101100 01101111
          01110010 01101001 01101110 01100111 00100000 01101110 01100101
          01110111 00100000 01110100 01100101 01100011 01101000 01101110
          01101111 01101100 01101111 01100111 01101001 01100101 01110011
          00101100 00100000 01101101 01111001 00100000 01100001 01101001
          01101101 00100000 01101001 01110011 00100000 01110100 01101111
          00100000 01100011 01110010 01100101 01100001 01110100 01100101
          00100000 01110110 01100001 01101100 01110101 01100101 00100000
          01110100 01101000 01110010 01101111 01110101 01100111 01101000
          00100000 01100101 01110110 01100101 01110010 01111001 00100000
          01110000 01110010 01101111 01101010 01100101 01100011 01110100
          00100000 01001001 00100000 01110101 01101110 01100100 01100101
          01110010 01110100 01100001 01101011 01100101 00101110 00001010
          00001010 01001100 01100101 01110100 00100111 01110011 00100000
          01100011 01101111 01101110 01101110 01100101 01100011 01110100
          00100000 01100001 01101110 01100100 00100000 01100101 01111000
          01110000 01101100 01101111 01110010 01100101 00100000 01101000
          01101111 01110111 00100000 01110111 01100101 00100000 01100011
          01100001 01101110 00100000 01100011 01101111 01101100 01101100
          01100001 01100010 01101111 01110010 01100001 01110100 01100101
          00100000 01101111 01101110 00100000 01110100 01110101 01110010
          01101110 01101001 01101110 01100111 00100000 01101001
        </p> */}
      </div>
      <div className="mainD">
        <div className="mainLeft">
          <h1>HI!</h1>
        </div>
        <div className="mainRight">
          <h3>Welcome to by personal website.</h3>
          <p>
            I have created this website to feel like a game/sci-fi interface.
            All text inside tries to reflect this. You will find ‘achievements’
            or ‘quests’ that show the progress in my professional life and are
            related to what I am working on.
          </p>
          <Link to="../Home" style={linkStyle} onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}> Enter System [Enter]</Link>
        </div>
      </div>
    </div>
  );
};

export default Index;
